<template>
  <span v-if="esHeader">
    <span
      ><b>{{ tituloHeader }}:</b>
      {{
        getFullNameByType(
          nombre,
          apellidos,
          razonSocial,
          isCompany(tipoUsuario)
        )
      }}</span
    >
  </span>
  <div v-else>
    <div v-if="isCompany(tipoUsuario)">
      <p>
        <b>{{ $t("common.razonSocial") }}:</b>
        {{
          getFullNameByType(
            nombre,
            apellidos,
            razonSocial,
            isCompany(tipoUsuario)
          )
        }}
      </p>
    </div>
    <div v-else>
      <p>
        <b>{{ $t("common.nombreCompleto") }}:</b>
        {{
          getFullNameByType(
            nombre,
            apellidos,
            razonSocial,
            isCompany(tipoUsuario)
          )
        }}
      </p>
    </div>
  </div>
</template>


<script>
import StringsMixin from "@/utils/strings";
import UsersMixin from "@/utils/users";
import validations from "@/utils/validations.js";
export default {
  mixins: [StringsMixin, UsersMixin],
  name: "NombreRazonSocialAcreedorDeudor",
  props: {
    tipoUsuario: String,
    idLegal: String,
    esHeader: Boolean,
    tituloHeader: String,
    nombre: String,
    apellidos: String,
    razonSocial: String,
  },
  data() {
    return {};
  },
  methods: {
    isCompany(tipoUsuario) {
      return (
        validations.validateNifEmpresa(this.idLegal) ||
        this.esEntidad(tipoUsuario)
      );
    },
  },
};
</script>


<style lang="scss" scoped>
</style>